module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_1.ec4f1cac.png";